import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectDashboard = (state) =>
  state.get('dashboardOverview') || initialState;
const makeSelectDashboard = () =>
  createSelector(selectDashboard, (tablesState) => tablesState);
const makeSelectLayout = () =>
  createSelector(selectDashboard, (tablesState) => tablesState.layout);

export { makeSelectDashboard, makeSelectLayout };
